import { takeEvery } from 'redux-saga/effects';
import {
  SEARCH_REQUEST,
  SEARCH_REQUEST_MOBILE,
  searchRequestEffect,
  searchRequestMobileEffect,
} from 'pages/search.page';

export const SearchPageSaga = function* () {
  yield takeEvery(SEARCH_REQUEST, searchRequestEffect);
  yield takeEvery(SEARCH_REQUEST_MOBILE, searchRequestMobileEffect);
};
